import { Fragment } from "react";
import { styled } from "styled-components";

import { SectionTitleUnderlined, StyledModalText as ModalText } from "common/components";
import { useFormatDate } from "common/utilities";
import { useSelector } from "common/utilities/react-redux";
import { getUnresolvedIncidents } from "domains/incidents/selectors";
import { ModalHeader } from "domains/modal/components/ModalHeader";

const StyledModalText = styled(ModalText)`
  margin: 0;
`;

const StyledModalTextContainer = styled.div`
  margin-bottom: 1rem;
`;

export const IncidentsModal = () => {
  const { getDate } = useFormatDate();
  const unresolvedIncidents = useSelector(getUnresolvedIncidents);

  return (
    <>
      <ModalHeader />
      {unresolvedIncidents.map(({ name, incidentUpdates }, incidentIndex) => (
        <Fragment key={incidentIndex}>
          <SectionTitleUnderlined>{name}</SectionTitleUnderlined>
          {incidentUpdates.map(({ displayAt, status, body }, updateIndex) => (
            <StyledModalTextContainer key={updateIndex}>
              <StyledModalText>
                <strong>
                  {status.charAt(0).toUpperCase()}
                  {status.substring(1)}
                </strong>
                {` - ${getDate({ date: displayAt })}`}
              </StyledModalText>
              <StyledModalText>{body}</StyledModalText>
            </StyledModalTextContainer>
          ))}
        </Fragment>
      ))}
    </>
  );
};
